import SEO from '../components/SEO';
import { strengths } from '../data';

export default function Strengths() {
  return (
    <div className="bg-white">
      <SEO />

      {/* Hero Header */}
      <section className="relative py-24 bg-stone-900 text-white">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214057.jpg" 
            alt="Tømrerhåndværk af Munkgaard Træbyg" 
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-900 via-stone-900/40 to-transparent" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col gap-4">
          <span className="text-white font-semibold tracking-[0.2em] uppercase text-xs">
            Hvorfor vælge os
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Vores styrker
          </h1>
          <p className="text-stone-300 text-lg max-w-2xl mx-auto">
            De værdier og principper, der sikrer dig et perfekt resultat og en tryg byggeproces
          </p>
        </div>
      </section>

      {/* Strengths Sections */}
      <section className="py-12">
        {strengths.map((strength, index) => {
          const isEven = index % 2 === 0;
          return (
            <div 
              key={strength.id}
              className={`py-20 border-b border-stone-100 last:border-0 ${
                isEven ? 'bg-white' : 'bg-stone-50/50'
              }`}
            >
              <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                {/* Icon & Title Side */}
                <div className={`lg:col-span-5 flex flex-col items-start gap-4 ${
                  isEven ? 'lg:order-1' : 'lg:order-2'
                }`}>
                  <div className="w-16 h-16 rounded-xl bg-stone-100 flex items-center justify-center text-accent text-3xl shadow-sm">
                    <i className={strength.icon} />
                  </div>
                  <h2 className="font-display text-3xl font-bold text-stone-900 mt-2">
                    {strength.title}
                  </h2>
                  <div className="h-1 w-20 bg-accent rounded-full" />
                </div>

                {/* Description Side */}
                <div className={`lg:col-span-7 ${
                  isEven ? 'lg:order-2' : 'lg:order-1'
                }`}>
                  <p className="text-stone-600 text-lg leading-relaxed">
                    {strength.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </section>

      {/* Call to action */}
      <section className="py-20 bg-stone-900 text-white text-center">
        <div className="max-w-3xl mx-auto px-6 flex flex-col gap-6">
          <h2 className="font-display text-3xl font-bold">Skal vi samarbejde om dit næste projekt?</h2>
          <p className="text-stone-400 text-base leading-relaxed">
            Vi står klar til at omsætte vores styrker og værdier til virkelighed på din byggeplads. Kontakt os i dag for en uforpligtende snak.
          </p>
          <div className="mt-4">
            <a 
              href="/kontakt" 
              className="bg-accent hover:bg-accent-light text-white px-8 py-4 rounded-md text-base font-semibold tracking-wide transition-all duration-300 inline-block"
            >
              Indhent et uforpligtende tilbud
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
